import { Grid } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import ContributionGroup from './ContributionGroup'
import EducationLevel from './EducationLevel'
import ProfessionalCategory from './ProfessionalCategory'
import RemoteContract from './RemoteContract'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
}

const Spain = ({ contractVersion }: Props) => {
  const canEdit = contractVersion._policies?.edit?.can ?? false
  const professionalCategory = contractVersion.spainProfessionalCategory?.name
  const cotizationGroup = contractVersion.a3TariffGroup?.name
  const educationLevel = contractVersion.spainEducationLevel?.name
  const hasRemoteContract = !!contractVersion.esHasTeleworkingContract

  const showProfessionalCategory = !!professionalCategory || canEdit
  const showCotizationGroup = !!cotizationGroup || canEdit
  const showEducationLevel = !!educationLevel || canEdit

  return (
    <Grid variant="fixed">
      {showProfessionalCategory && (
        <ProfessionalCategory
          professionalCategory={contractVersion.spainProfessionalCategory?.name}
        />
      )}
      {showCotizationGroup && <ContributionGroup cotizationGroup={cotizationGroup} />}
      {showEducationLevel && <EducationLevel educationLevel={educationLevel} />}
      <RemoteContract hasRemoteContract={hasRemoteContract} />
    </Grid>
  )
}

export default Spain
